// SearchContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const SearchContext = createContext(null);

export const useSearch = () => useContext(SearchContext);

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsPage, setSearchResultsPage] = useState(1);
  const [searchResultsTotalPages, setSearchResultsTotalPages] = useState(1);

  // Clear search function
  const clearSearch = useCallback(() => {
    setSearchQuery("");
    setHasSearched(false);
    setSearchResults([]);
    setIsSearching(false);
    setSearchResultsPage(1);
    setSearchResultsTotalPages(1);
  }, []);

  // Handle search on Enter key press
  const handleSearchKeyPress = useCallback(
    (e) => {
      if (e.key === "Enter") {
        // This will be handled by the component that has the search logic
        const event = new CustomEvent('search-trigger');
        window.dispatchEvent(event);
      }
    },
    []
  );

  const value = {
    searchQuery,
    setSearchQuery,
    isSearching,
    setIsSearching,
    hasSearched,
    setHasSearched,
    searchResults,
    setSearchResults,
    searchResultsPage,
    setSearchResultsPage,
    searchResultsTotalPages,
    setSearchResultsTotalPages,
    clearSearch,
    handleSearchKeyPress
  };

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchContext;
